import { render, staticRenderFns } from "./PoClientsList.vue?vue&type=template&id=dd9af1d2"
import script from "./PoClientsList.vue?vue&type=script&lang=js"
export * from "./PoClientsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports